import api from './fetch/api'
import axios from './fetch/filterHttp'


/**
 * 封装基础ajax请求
 * @param {any}
 */
class BaseApi {
	//
	login = (params) => api('admin/login', params,"GET")

	// 文件上传
	file_upload = (formData) => {
		// 获取token和userid
		let token = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : ''
		let userid = localStorage.getItem('userid') ? localStorage.getItem('userid') : ''

		return axios.post('admin_pic_upload', formData, {
			headers: {
				'UUID': userid,
				'token': token,
				'Content-Type': 'multipart/form-data'
			}
		})
	}

}

// 实例化再导出
export default new BaseApi();



// WEBPACK FOOTER //
// ./src/api/BaseApi.js